module.exports = __webpack_public_path__ + "static/media/CTLI_4-315w.e574d4d6.png";